package fr.frux.shared.data.local

import fr.frux.shared.dto.SpeciesDto

/** Referentiel tel que persiste localement, avec l'ETag a rejouer en revalidation (#177). */
data class CachedSpecies(
    val etag: String?,
    val species: List<SpeciesDto>,
)

/**
 * Persistance locale du referentiel d'especes (#177, suite de l'epic #8). Cache de lecture pure :
 * ecrit uniquement depuis une reponse serveur complete, jamais de mutation locale.
 */
interface SpeciesLocalDataSource {
    /** Rend null si le cache est vide ou illisible (payload d'une version incompatible). */
    suspend fun read(): CachedSpecies?

    suspend fun write(
        etag: String?,
        species: List<SpeciesDto>,
    )
}

/** Repli des cibles sans SQLite (web) : cache toujours vide, ecritures ignorees. */
object NoOpSpeciesLocalDataSource : SpeciesLocalDataSource {
    override suspend fun read(): CachedSpecies? = null

    override suspend fun write(
        etag: String?,
        species: List<SpeciesDto>,
    ) = Unit
}
